export enum ExternalMemberFormIds {
  language = 'language',
  longDescription = 'longDescription',
  emailAddress = 'emailAddress',
  name = 'name'
}

export const languageValidationParameter = 'description';
export const longDescriptionValidationParameter = 'longDescription';
export const maxDescriptionLength = 254;
export const maxLengthOfEmailInputValue = 4000;
